/**
 * Props à répandre sur un `<a>` dont l'`href` vient d'un champ éditable BO
 * (`cta_target` : richfields, staticContent). L'URL n'est jamais connue à
 * l'avance — elle peut viser le site du salon comme un site tiers — donc on
 * ouvre en nouvel onglet uniquement quand l'URL est **absolue**, jamais sur un
 * `#ancre`, un chemin relatif ou un `tel:`/`mailto:` : rien de ces derniers ne
 * doit décharger la page ou ouvrir un onglet inutile.
 *
 * `rel="noopener noreferrer"` seulement — jamais `nofollow`. C'est justement
 * ce que `common/RichFieldNewsfeed` fait de travers (§6.4 du plan : il colle
 * `nofollow` sur tous les liens sans distinction) : un `nofollow` sur un lien
 * vers une page de vraies prestations couperait le maillage SEO que la page
 * est censée construire. `target="_blank"` seul n'a aucun effet sur
 * l'indexation ou le crawl — Google suit et attribue le lien normalement.
 */
const externalLinkProps = (href) => {
  if (!/^https?:\/\//i.test(href || '')) return {};
  return { target: '_blank', rel: 'noopener noreferrer' };
};

export default externalLinkProps;
